import { render, staticRenderFns } from "./ProrrogarReservaDialog.vue?vue&type=template&id=1436c638&"
import script from "./ProrrogarReservaDialog.vue?vue&type=script&lang=js&"
export * from "./ProrrogarReservaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports